export const COMPUTER_THOUSAND = 1024;

export enum ComputerPrefixExponents {
  BYTE = 0,
  KILO,
  MEGA,
  GIGA,
  TERA,
}
